import { render, staticRenderFns } from "./DialogNewebpay.pug?vue&type=template&id=5cc7a4c6&scoped=true&lang=pug&"
import script from "./DialogNewebpay.vue?vue&type=script&lang=js&"
export * from "./DialogNewebpay.vue?vue&type=script&lang=js&"
import style0 from "./DialogNewebpay.vue?vue&type=style&index=0&id=5cc7a4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc7a4c6",
  null
  
)

export default component.exports